/**
 * 倒計時
 * @param s 秒數
 * @param callback  回調
 */
export const countdownTimer = (s = 60, callback) => {
  let count = s;
  const timer = () => {
    setTimeout(() => {
      if (count > 0) {
        callback(count);
        count -= 1;
        timer();
      } else {
        callback(null);
        clearTimeout(timer);
      }
    }, 1000);
  };
  timer();
};

/**
 * 判断是否为数字
 * */
export function isNumber(val) {
  const regPos = /^\d+(\.\d+)?$/; // 非负浮点数
  const regNeg =
    /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/; // 负浮点数
  if (regPos.test(val) || regNeg.test(val)) {
    return true;
  }
  return false;
}

/**
 * 邮箱
 * @param {*} s
 */
export function isEmail(s) {
  // return /^([a-zA-Z0-9._-])+@([a-zA-Z0-9_-])+((.[a-zA-Z0-9_-]{2,3}){1,2})$/.test(s)
  return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(s);
}

/**
 * 手机号码
 * @param {*} s
 */
export function isMobile(s) {
  return /^1[0-9]{10}$/.test(s);
}

/**
 * 座機
 * @param {*} s
 */
export function isPhone(s) {
  return /^([0-9]{3,4}-)?[0-9]{7,8}$/.test(s);
}

/**
 * 密碼
 * 密码由8位数字、大小写字母和特殊符号组成
 * @param {*} s
 */
export function isPassword(s) {
  return /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+`\-={}:";'<>?,./]).{8,}$/.test(s);
}

/**
 * URL地址
 * @param {*} s
 */
export function isURL(s) {
  return /^http[s]?:\/\/.*/.test(s);
}

/**
 * 中文
 * @param {*} s
 */
export function isChinese(s) {
  return /[\u4E00-\u9FA5]/g.test(s);
}

/**
 * 用戶名
 * 用戶名由数字、字母组成
 * @param {*} s
 */
export function isUsername(s) {
  return /^(?=.*[a-zA-Z])(?=.*\d)/.test(s);
}

/**
 * 构造树型结构数据
 * @param {*} data 数据源
 * @param {*} id id字段 默认 'id'
 * @param {*} parentId 父节点字段 默认 'parentId'
 * @param {*} children 孩子节点字段 默认 'children'
 */
export function handleTree(data, id, parentId, children) {
  const config = {
    id: id || 'id',
    parentId: parentId || 'parentId',
    childrenList: children || 'children'
  };

  const childrenListMap = {};
  const nodeIds = {};
  const tree = [];

  // eslint-disable-next-line no-restricted-syntax
  for (const d of data) {
    const parentId = d[config.parentId];
    if (childrenListMap[parentId] == null) {
      childrenListMap[parentId] = [];
    }
    nodeIds[d[config.id]] = d;
    childrenListMap[parentId].push(d);
  }

  // eslint-disable-next-line no-restricted-syntax
  for (const d of data) {
    const parentId = d[config.parentId];
    if (nodeIds[parentId] == null) {
      tree.push(d);
    }
  }

  // eslint-disable-next-line no-restricted-syntax
  for (const t of tree) {
    adaptToChildrenList(t);
  }

  function adaptToChildrenList(o) {
    if (childrenListMap[o[config.id]] !== null) {
      o[config.childrenList] = childrenListMap[o[config.id]];
    }
    if (o[config.childrenList]) {
      // eslint-disable-next-line no-restricted-syntax
      for (const c of o[config.childrenList]) {
        c.menuLevel = 3;
        adaptToChildrenList(c);
      }
    }
  }
  return tree;
}

// 樹形數據扁平化-函数式风格，代码简洁
export function treeTransList(tree, key) {
  return tree
    .reduce(function (con, item) {
      // eslint-disable-next-line prefer-rest-params,no-restricted-properties
      const { callee } = arguments;
      con.push(item);
      if (item[key] && item[key].length > 0) item[key].reduce(callee, con);
      return con;
    }, [])
    .map((item) => {
      item[key] = [];
      return item;
    });
}

// 樹形數據扁平化-迭代法性能最好
export function treeToList(tree, childName = 'children') {
  // 设置临时数组，用来存放队列
  let queen = [];
  // 设置输出数组，用来存放要输出的一维数组
  const result = [];
  queen = queen.concat(tree);
  // 对树对象进行广度优先的遍历
  while (queen.length) {
    const first = queen.shift();
    if (first[childName]) {
      queen = queen.concat(first[childName]);
      delete first[childName];
    }
    result.push(first);
  }
  return result;
}

/*
* 隨機數
* min ~ max
*/
export function getRandomInt(min, max) {
  return Math.floor(Math.random() * (max-min+1)+min)
}

/*
* star 代替
* */
export const obscureEmail = (email) => {
  const [name, domain] = email.split('@');
  if(name.length > 1) {
    return `${name[0]}${name[1]}${new Array(name.length - 1).join('*')}@${domain}`;
  }
  return `${name[0]}${new Array(name.length).join('*')}@${domain}`;
};
export const formatEmail = (emilString) =>{
  const splitEmail = emilString.split("@");
  const name = splitEmail[0];
  const domain = splitEmail[1];
  return name.substring(0,3).concat(`${new Array(name.length - 2).join('*')}@`).concat(domain)
}
export function maskingString(str, start = 2, end = 8) {
  if (!str || start < 0 || start >= str.length || end < 0 || end > str.length || start >= end) {
    return str;
  }
  const maskLength = end - start;
  const maskedStr = str.substring(0, start) + "*".repeat(maskLength) + str.substring(end);
  return maskedStr;
}

// 文件下載EXCEL
export function downloadFile(data, fileName = String(new Date().getTime())) {
  const url = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement('a');
  link.style.display = 'none';
  link.href = url;
  link.setAttribute('download', `${fileName}.xlsx`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link); // 下载完成移除元素
  window.URL.revokeObjectURL(url); // 释放掉blob对象
};

// 文件下載
export function downloadDocument(data, fileName = String(new Date().getTime()), successCallback) {
  const x = new XMLHttpRequest();
  x.open('GET', data, true);
  x.responseType = 'blob';
  x.onload = function() {
    const url = window.URL.createObjectURL(x.response);
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    a.download = fileName;
    a.click();
    successCallback?.();
  };
  x.send();
};


// 文件後綴
export function getFileExtension(filename, delimiter = '.'){
  // get file extension
  const extension = filename.split(delimiter).pop();
  return extension;
}

// 移除樹結構中某個包含某個值得對象
export function removeNodeByCodeReduce(tree = [], codeToRemove){
  return tree?.reduce((acc, node) => {
    if (node?.contentCode !== codeToRemove) {
      const newNode = { ...node };
      if (Array.isArray(newNode?.children)) {
        newNode.children = removeNodeByCodeReduce(newNode.children, codeToRemove);
      }
      acc.push(newNode);
    }
    return acc;
  }, []);
 }

 
 /**
 * 判斷兩個數組中，相同 ID 的某個字段是否相等
 * @param {Array} array1 - 第一個數組
 * @param {Array} array2 - 第二個數組
 * @param {string} idField - 用於匹配的 ID 字段名稱
 * @param {string} compareField - 用於比較的字段名稱
 * @returns {boolean} - 如果不相等返回 true，相等返回 false
 */
 export function isFieldDifferent(
  arr1=[],
  arr2=[],
  idKey = 'id',
  compareField
) {
  // 长度检查
  if (arr1.length !== arr2.length) return true;

  // ID集合检查
  const ids1 = new Set(arr1.map(item => item[idKey]));
  const ids2 = new Set(arr2.map(item => item[idKey]));
  if (![...ids1].every(id => ids2.has(id))) return true;

  // 字段比较
  const arr2Map = new Map(arr2.map(item => [item[idKey], item]));
  return arr1.some(item1 => {
    const item2 = arr2Map.get(item1[idKey]);
    return item2?.[compareField] !== item1[compareField];
  });
};


export function checkFieldsDifference(array, field1, field2) {
  return array.every((item) => {
    const value1 = item[field1];
    const value2 = item[field2];
    // 確保字段存在且為數字
    if (typeof value1 !== 'number' || typeof value2 !== 'number') {
      return false; // 若字段不存在或非數字，返回 false
    }
    return value1 - value2 === 0; // 檢查相減是否等於 0
  });
 }


/**
 * 判斷兩個列表中是否存在 id 相同且 needNum 值相同的項目
 * @param {Array} array1 - 第一個列表
 * @param {Array} array2 - 第二個列表
 * @param {string} idField - 用於匹配的 ID 字段名稱
 * @param {string} compareField - 用於比較的字段名稱 (默認為 'needNum')
 * @returns {boolean} - 如果所有匹配項目 needNum 值相同，返回 true；否則返回 false
 */
export function validateFieldsDifference(array1 = [], array2 = [], idField = 'id', compareField = 'needNum') {
  // 如果數組長度不相等，直接返回 false
  if (array1.length !== array2.length) {
    return false;
  }

  // 將第二個數組轉換為 Map，方便通過 ID 快速查找
  const map2 = new Map(array2.map(item => [item[idField], item[compareField]]));

  // 遍歷第一個數組，檢查是否所有匹配項目 needNum 值相同
  return array1.every(item1 => {
    const value2 = map2.get(item1[idField]);
    return value2 === item1[compareField];
  });
}